export enum ProgressTypes {
	ACTION = 'actions',
	DATES = 'dates',
	CREATOR = 'creator',
}
